import { ArrowLeft } from "lucide-react"
import { Button } from "shared-web/components/base/control/Button"

import { useSignInContext } from "./SignInContext"
import {
  StepCard,
  StepCardBody,
  StepCardFooter,
  StepCardTitle,
} from "./StepCard"
import { StepIDInput } from "./StepIDInput"

export interface StepKeyIDProps {
  onSubmit: (staffExternalID: string) => void
  isSubmitting: boolean
  errorMessage: string | null
}

export function StepKeyID({
  onSubmit,
  isSubmitting,
  errorMessage,
}: StepKeyIDProps) {
  const { setStep } = useSignInContext()

  return (
    <StepCard>
      <StepCardTitle>Sign in using key</StepCardTitle>
      <StepCardBody className="items-center gap-y-4">
        <StepIDInput
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          errorMessage={errorMessage}
        />
      </StepCardBody>
      <StepCardFooter>
        <Button
          className="w-full"
          mode="ghost"
          leftIcon={ArrowLeft}
          onClick={() => setStep("key")}
        >
          Use a different sign-in method
        </Button>
      </StepCardFooter>
    </StepCard>
  )
}
